import { Prisma } from "@prisma/client";
import { Paginated, Sortable } from "./utils.types";
import { EventFormQuestionAnswerType } from "./event-form-question.types";

export const eventFormAnswersArgs =
  Prisma.validator<Prisma.EventFormAnswerDefaultArgs>()({
    select: {
      id: true,
      answer: true,
      answerList: true,
      createdAt: true,
      updatedAt: true,
      questionOnEvent: {
        select: {
          questionId: true,
          eventId: true,
        },
      },
      eventFormAnswerUser: {
        select: {
          userId: true,
        },
      },
    },
  });

export type EventFormAnswer = Prisma.EventFormAnswerGetPayload<
  typeof eventFormAnswersArgs
>;

export const eventFormAnswerDataArgs =
  Prisma.validator<Prisma.EventFormAnswerDefaultArgs>()({
    select: {
      answer: true,
      answerList: true,
      questionOnEvent: {
        select: {
          question: {
            select: { theme: true },
          },
        },
      },
      eventFormAnswerUser: {
        select: {
          id: true,
          eventId: true,
          userId: true,
          user: {
            select: { email: true },
          },
        },
      },
    },
  });

export type EventFormAnswerData = Prisma.EventFormAnswerGetPayload<
  typeof eventFormAnswerDataArgs
>;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface EventFormAnswerFiltersBase {
  // No additional filters for now
}

export type EventFormAnswerFilters = Sortable<
  Paginated<EventFormAnswerFiltersBase>
>;

export const eventFormAnswerChannelValues = ["online", "cash_register"] as const;

export type EventFormAnswerChannel = (typeof eventFormAnswerChannelValues)[number];

// Shared by the backoffice table and the XLSX export so both name the channel the same way
export const eventFormAnswerChannelLabels: Record<EventFormAnswerChannel, string> = {
  online: "En ligne",
  cash_register: "Guichet",
};

export interface EventFormAnswerExport {
  // Empty for a cash register sale: no buyer identity is collected at the counter
  userEmail: string;
  channel: EventFormAnswerChannel;
  answers: Record<string, string>; // theme -> answer value (comma-separated for multiple answers)
}

export interface EventFormAnswersExportResponse {
  data: EventFormAnswerExport[];
  count: number;
  questions: Array<{
    id: string;
    theme: string;
    question: string;
    answerType: EventFormQuestionAnswerType;
    columnKey: string;
  }>;
}

export interface VisitorEventFormAnswerItem {
  questionId: string;
  theme: string;
  question: string;
  answerType: EventFormQuestionAnswerType;
  options: { id: string; label: string }[];
  answer: string | null;
  answerList: string[];
}

export interface VisitorEventFormAnswersResponse {
  questions: VisitorEventFormAnswerItem[];
  user: {
    email: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
}
